import { CURRENCIES, type Currency } from '@chukua/common';
import { Form, Input, Select } from 'antd';
import { parseAmount } from '../policies/receipt-form';

const CURRENCY_OPTIONS = CURRENCIES.map((currency) => ({ value: currency, label: currency }));

/** The amount in major units with its currency beside it; it becomes integer minor units only in `toReceiptInput`. */
export function ReceiptAmountField() {
  const form = Form.useFormInstance();

  return (
    <Form.Item
      name="amount"
      label="Amount"
      dependencies={['currency']}
      rules={[
        {
          validator: (_, value?: string) => {
            const check = parseAmount(value, form.getFieldValue('currency') as Currency);
            return check.ok ? Promise.resolve() : Promise.reject(new Error(check.reason));
          },
        },
      ]}
    >
      <Input
        inputMode="decimal"
        addonBefore={
          <Form.Item name="currency" noStyle>
            <Select aria-label="Currency" options={CURRENCY_OPTIONS} className="w-20" />
          </Form.Item>
        }
      />
    </Form.Item>
  );
}
